﻿window.supportCompteAuxilios = null
window.cObjetSupportTicketMetier = function (objet) {
    var Me = this;
    this.data = objet.data;
    this.objet = objet;

    this.mGetLibBase = function () { return "Ticket"; }
    this.mGetAttributBase = function () { return "le" }
    this.mGetNewLib = function () { return "Nouveau ticket"; }
    this.mGetLib1 = function (option) {
        var txt = ""
        if (typeof objet.data != 'undefined') { txt = ((objet.data.objet) ? objet.data.objet : "(aucun objet)") }
        else {
            txt = "ticket"
        }
        if (typeof option != 'undefined' && typeof option.callBack != 'undefined') { option.callBack(txt) }
        else { return txt }
    }
    this.mGetLib2 = function () {
        return ""
    }

    this.mGetRadiusImage = function () { return "0" }
    this.mGetResume = function () {
        var txt = "";
        return txt;
    }

    this.mGetIcone = function (dataTemplate) {
        var $Icone = null;
        var toolTip = "Ticket"
        $Icone = $("<i class='fas fa-user-doctor'></i>");
        $Icone.attr("title", toolTip)
        return $Icone
    }

    this.contentTemplateGrid = function (contentElement, option) {
        contentElement.empty();

    }

    this.mGetItemTemplateHeight = function (type) {
        return ((type == "Détails") ? 87 : 53)
    }
    this.itemTemplateGrille = function (contentElement, dataTemplate, type, option) {
        var $Table = $("<table style='table-layout:fixed;width:100%;text-align:left;line-height:1.2;'/>").appendTo(contentElement)

        var $TdImageCreateur = null
        var $TdLibCreateur = null
        if (type == "Détails") {
            var $Tr = $("<tr/>").appendTo($Table)
            var $TdReste = $("<td style='width:100%;'/>").appendTo($Tr)

            var $TdIndic = $("<td style='width:100px;vertival-align:top;text-align:center;'/>").appendTo($Tr)
            if (dataTemplate.ouvert == 1) {
                $("<div style='background-color:rgb(255, 153, 153);border-radius:5px;padding:3px;'>OUVERT</div>").appendTo($TdIndic);
            } else {
                $("<div style='background-color:rgb(0, 153, 0);border-radius:5px;padding:3px;'>FERME</div>").appendTo($TdIndic);
            }
            if (dataTemplate.resolue == 1) {
                $("<div style='background-color:rgb(153, 153, 0);border-radius:5px;padding:3px;margin-top:3px;'>RESOLUE</div>").appendTo($TdIndic);
            }
            if (dataTemplate.attente_utilisateur != null) {
                if (dataTemplate.attente_utilisateur == "2") {
                    $("<div style='border-radius:5px;background-color:rgb(128, 128, 255);padding:3px;font-weight:bold;width:100%;opacity:0.5;margin-top:3px;'>AU SUPPORT</div>").appendTo($TdIndic)
                } else if (dataTemplate.attente_utilisateur == "1") {
                    $("<div style='border-radius:5px;background-color:rgb(128, 128, 255);padding:3px;font-weight:bold;width:100%;margin-top:3px;'>A VOUS</div>").appendTo($TdIndic)
                }
            }

            var $TableUti = $("<table style='width:100%;table-layout:fixed;'/>").appendTo($TdReste)
            var $Tr = $("<tr/>").appendTo($TableUti)
            $TdImageCreateur = $("<td style='width:60px;text-align:center;display:none;'/>").appendTo($Tr)
            $TdLibCreateur = $("<td style='width:100%'/>").appendTo($Tr)



            var $TableObj = $("<table style='width:100%;table-layout:fixed;'/>").appendTo($TdReste)
            var $Tr = $("<tr/>").appendTo($TableObj)
            if (dataTemplate.nb_fichier_joint > 0) {
                var $TdFile = $("<td style='width:26px;text-align:center;padding:0 3px;' class='dx-theme-accent-as-text-color'></td>").appendTo($Tr)
                $("<i class='fas fa-paperclip'></i><sup style='font-size:70%'>" + dataTemplate.nb_fichier_joint + "</sup>").appendTo($TdFile)
            }
            var $TdObjet = $("<td style='width:100%;text-align:left;padding:0 3px;font-weight:bold;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;'></td>").appendTo($Tr)
            $TdObjet.text(dataTemplate.objet)

            var $TableBody = $("<table style='width:100%;table-layout:fixed;'/>").appendTo($TdReste)
            var $Tr = $("<tr/>").appendTo($TableBody)
            var $TdBody = $("<td style='width:100%;text-align:left;padding:0 3px;opacity:0.5;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;'></td>").appendTo($Tr)
            $TdBody.text(dataTemplate.body_txt)
            if (dataTemplate.body_txt_last_child != null) {
                var $Div = $("<div style='font-style:italic;;font-weight:bold;font-size:100%;white-space:normal;' class='ellipsismultiligne3'/>").appendTo($TdBody)
                $("<span style='opacity:0.5;font-size:80%;'>Dernière réponse: </span>").appendTo($Div)
                var $S = $("<span/>").appendTo($Div)
                $S.text(dataTemplate.body_txt_last_child)
            }
        } else {
            var $Tr = $("<tr/>").appendTo($Table)
            //if (supportCompteAuxilios == null) {
            //    $("<td style='width:70px;'><div style='font-family:barlow condensed;background-color:" + theme.backgroundColorTitle + ";border-radius:5px;text-align:center;padding:3px;'>" + dataTemplate.code_appli + "</div></td>").appendTo($Tr)
            $TdImageCreateur = $("<td style='width:30px;text-align:center;'/>").appendTo($Tr)
            $TdLibCreateur = $("<td style='width:250px;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;'/>").appendTo($Tr)
            //}
            if (dataTemplate.nb_fichier_joint > 0) {
                var $TdFile = $("<td style='width:26px;text-align:center;padding:0 3px;' class='dx-theme-accent-as-text-color'></td>").appendTo($Tr)
                $("<i class='fas fa-paperclip'></i><sup style='font-size:70%'>" + dataTemplate.nb_fichier_joint + "</sup>").appendTo($TdFile)
            }
            var $TdObjetBody = $("<td style='width:100%;text-align:left;padding:0 3px;font-weight:bold;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;'></td>").appendTo($Tr)
            $TdObjetBody.html("<b>" + dataTemplate.objet + "</b> &bull; <span style='opacity:0.5;font-style:italic;'>" + ((dataTemplate.last_body_txt == null) ? dataTemplate.body_txt : dataTemplate.last_body_txt) + "</span>")
            var $TdStatut = $("<td style='width:60px;text-align:center;padding:0 3px;'></td>").appendTo($Tr)
            if (dataTemplate.ouvert == 1) {
                $("<div style='background-color:rgb(255, 153, 153);border-radius:5px;padding:3px;'>OUVERT</div>").appendTo($TdStatut);
            } else {
                $("<div style='background-color:rgb(0, 153, 0);border-radius:5px;padding:3px;'>FERME</div>").appendTo($TdStatut);
            }
            if (dataTemplate.resolue == 1) {
                var $TdStatut = $("<td style='width:60px;text-align:center;padding:0 3px;'></td>").appendTo($Tr)
                $("<div style='background-color:rgb(153, 153, 0);border-radius:5px;padding:3px;'>RESOLUE</div>").appendTo($TdStatut);
            }
            //switch (parseInt(dataTemplate.id_statut_ticket)) {
            //    case 0: $("<div style='background-color:red;border-radius:5px;padding:3px;'>OUVERT</div>").appendTo($TdStatut); break;
            //    case 1: $("<div style='background-color:orange;border-radius:5px;padding:3px;'>RESOLUE</div>").appendTo($TdStatut); break;
            //    case 2: $("<div style='background-color:green;border-radius:5px;padding:3px;'>FERME</div>").appendTo($TdStatut); break;
            //}
            if (dataTemplate.attente_utilisateur != null) {
                var $TdAVous = $("<td style='width:100px;text-align:center;padding:0;'></td>").appendTo($Tr)
                if (dataTemplate.attente_utilisateur == "2") {
                    $("<div style='border-radius:5px;background-color:rgb(128, 128, 255);padding:3px;font-weight:bold;width:100%;opacity:0.5;'>AU SUPPORT</div>").appendTo($TdAVous)
                } else if (dataTemplate.attente_utilisateur == "1") {
                    $("<div style='border-radius:5px;background-color:rgb(128, 128, 255);padding:3px;font-weight:bold;width:100%;'>A VOUS</div>").appendTo($TdAVous)
                }
            }
        }
        if (dataTemplate.lu == 0) contentElement.closest(".divtemplate").css("box-shadow", "-0.5px 0 10px 3.5px #000000")

        objet.bddRef.mAjaxCall({
            command: "getdatautilisateurcreateursupportticket",
            "id_compte_client": dataTemplate.id_compte_client,
            "id_utilisateur_client": dataTemplate.id_utilisateur_client
        }, function (data) {
            if (typeof data.img64 == 'undefined' || data.img64.length == 0) {
                $("<i class='fas fa-user' style='font-size:" + ((type == "Détails") ? "40px" : "20px") + ";'/>").appendTo($TdImageCreateur)
            } else {
                $("<img src='" + data.img64 + "' style='width:" + ((type == "Détails") ? "50px" : "20px") + ";border-radius:50%;'/>").appendTo($TdImageCreateur)
            }
            $TdLibCreateur.html("&nbsp;" + ((dataTemplate.id_utilisateur_client == "0") ? "CPTCLI" : "UTI") + " &bull; " + data.lib + " &bull; " + parametre.entete_ticket_support + dataTemplate.id_key)
        })
    }
    this.itemTemplateGrillePlus = function (contentElement, dataPlus) {
        $("<span style='' title='Créé le " + dataPlus.dcr.toFrenchDateTime() + "'><i class='fas fa-certificate dx-theme-accent-as-text-color' style='padding-right:3px;'></i>" + dataPlus.dcr.toDateIlya(true) + "</span>").appendTo(contentElement)
        if (dataPlus.dcr.toDateIlya(true) != dataPlus.dmo.toDateIlya(true)) {
            $("<br/><span style='' title='Modifié le " + dataPlus.dmo.toFrenchDateTime() + "'><i class='fas fa-pen dx-theme-accent-as-text-color' style='padding-right:3px;'></i>" + dataPlus.dmo.toDateIlya(true) + "</span>").appendTo(contentElement)
        }
        if (objet.bddRef.nom_base.endsWith("_aagest")) {
            var $SpanClickVue = $("<span/>").appendTo(contentElement)
            if (dataPlus.last_date_vue != null) {
                var $S = $("<br/><span><i class='fas fa-eye dx-theme-accent-as-text-color' style='padding-right:3px;'></i>(" + dataPlus.nb_vue + ") " + dataPlus.last_date_vue.toDateIlya(true) + "</span>").appendTo($SpanClickVue)
                $S.attr("title", "Dernière vue sur la dernière réponse utilisateur le " + dataPlus.last_date_vue.toFrenchDateTime())
            }
            if (dataPlus.last_date_click != null) {
                var $S = $("<br/><span><i class='fas fa-arrow-pointer dx-theme-accent-as-text-color' style='padding-right:3px;'></i>(" + dataPlus.nb_click + ") " + dataPlus.last_date_click.toDateIlya(true) + "</span>").appendTo($SpanClickVue)
                $S.attr("title", "Dernier click sur la dernière réponse utilisateur le " + dataPlus.last_date_click.toFrenchDateTime())
            }
        }
    }

    this.mHasTabPopup = function () {
        return ((supportCompteAuxilios == null) ? true : false)
    }
    this.mGetWidthPopup = function () {
        return 650
    }
    this.isPopupFullScreen = false
    //this.mShowPopup = function (option) {
    //    if (typeof option == 'undefined') option = {}
    //    option.fullScreen = false
    //    page.mAddPopup(objet.data, option)
    //}
    this.contentTemplatePopup = function (contentElement, option) {
        contentElement.empty();
        contentElement.css("padding", "0 20px 20px 20px")
        var dxCtrl = $("<div style='height:100%;width:100%;'/>").appendTo(contentElement).dxCtrlContentSupport({
            bddCtrl: objet.bddRef,
            data: objet.data,
            optionPopup: option
        }).dxCtrlContentSupport("instance")
    }

}